import { render } from "./UploadServer.vue?vue&type=template&id=56fb18d6"
import script from "./UploadServer.vue?vue&type=script&lang=js"
export * from "./UploadServer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__